export const DEFAULT_DELAY = 3000;
export const DANGER_STATUS_DEFAULT_DELAY = 15000;
